import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=bf67e35e&scoped=true&"
import script from "./page4.vue?vue&type=script&lang=js&"
export * from "./page4.vue?vue&type=script&lang=js&"
import style0 from "./page4.vue?vue&type=style&index=0&id=bf67e35e&lang=scss&scoped=true&"
import style1 from "./page4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf67e35e",
  null
  
)

export default component.exports